module.exports = __webpack_public_path__ + "img/emptyProject.c475609e.png";